// theme.js
import { createTheme } from "@mui/material/styles";

const NAV_COLOR = "#262626";
const NAV_BORDER = "1px solid rgba(255,255,255,0.1)";

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#4dabf7" },
    secondary: { main: "#82cfff" },
    background: {
      default: "#000000",
      paper: "#262626",
    },
    text: {
      primary: "#ffffff",
      secondary: "rgba(255,255,255,0.7)",
    },
    error: { main: "#ff6b6b" },
    success: { main: "#51cf66" },
    warning: { main: "#fcc419" },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: NAV_COLOR,
          // borderBottom: NAV_BORDER,
          backgroundImage: "none",
          boxShadow: "none",
        },
      },
    },

    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: "#262626",
          backgroundImage: "none",
          boxShadow: "none",
        },
      },
    },

    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: "#121212",
          // borderRadius: 12,
        },
      },
    },

    MuiAlert: {
      styleOverrides: {
        filled: {
          color: "#fff",
        },
      },
    },
  },
});

export default theme;
